import { render, staticRenderFns } from "./AdminDashboardLayout.vue?vue&type=template&id=b2f44f42&"
import script from "./AdminDashboardLayout.vue?vue&type=script&lang=js&"
export * from "./AdminDashboardLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports